module.exports = __webpack_public_path__ + "img/gala-passport.edfdbea2.svg";